import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MViewDetailNotifForm from './MViewDetailNotifForm';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import { getReportNotif } from './redux/reduxApi';

const mapState = (state, ownProps) => {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;
  let reportNotif = state.latihans?.reportNotif;
  return {
    scope,
    loading,
    reportNotif,
  };
};

const actions = {
  closeModal,
  getReportNotif,
};

function ModalViewDetailNotif({
  scope,
  loading,
  closeModal,
  data,
  getReportNotif,
  reportNotif
}) {
  const id = data?.id;
  const auth = data?.auth;
  const history = useHistory();
  const screenWidth = useScreenWidth();
  const item = data?.item;

  useEffect(() => {
    getReportNotif(auth, history, item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormSubmit = async (values) => {};

  return (
    <Modal
      variant='info'
      label='Report Notifikasi'
      closeModal={closeModal}
      width={screenWidth > 600 ? 600 : screenWidth}
    >
      <MViewDetailNotifForm
        id={id}
        auth={auth}
        scope={scope}
        loading={loading}
        history={history}
        closeModal={closeModal}
        initialValues={reportNotif}
        onFormSubmit={onFormSubmit}
      />
    </Modal>
  );
}

export default withRouter(connect(mapState, actions)(ModalViewDetailNotif));
